module.exports = __webpack_public_path__ + "img/header-memoireRingsAsWeddingRings.c2f0b60.webp";